<template>
    <div v-else class="Chat__info">
        <i class="fas fa-user Chat__info-icon"></i>
        <h3 class="Chat__info-title">Sélectionnez un employé</h3>
        <p class="Chat__info-text">
            Veuillez choisir un employé afin de voir les suggestions de formation.
        </p>
    </div>
</template>

<script>
    export default {
    }
</script>
